/**
 * User profile API – all endpoints used by profile pages.
 * Base path: /org/userprofile (user profile routes mounted in backend userRoutes).
 */
import { GET, POST, UPLOAD_FILE } from '../apiController';

const ORG_USER_PROFILE = '/user/userprofile';

export const getProfile = () => {
  return GET(`${ORG_USER_PROFILE}/get_profile`);
};

export const editProfile = (data) => {
  return POST(`${ORG_USER_PROFILE}/edit_profile`, data);
};

export const updateProfilePic = (data) => {
  return UPLOAD_FILE(`${ORG_USER_PROFILE}/update_profile_pic`, data);
};

export const changePassword = (data) => {
  return POST(`${ORG_USER_PROFILE}/change_password`, data);
};

export const getProfileComments = (user_id) => {
  return GET(`${ORG_USER_PROFILE}/get_profile_comments/${user_id}`);
};

/** @deprecated Use get2FAStatus / initiate2FASetup / verifyAndEnable2FA / disable2FA */
export const setTfaEnabled = (tfa_enabled) => {
  return POST(`${ORG_USER_PROFILE}/set_tfa`, tfa_enabled);
};

export const get2FAStatus = () => {
  return GET(`${ORG_USER_PROFILE}/2fa/status`);
};

export const initiate2FASetup = () => {
  return GET(`${ORG_USER_PROFILE}/2fa/setup`);
};

export const verifyAndEnable2FA = (code) => {
  return POST(`${ORG_USER_PROFILE}/2fa/verify`, { code });
};

export const disable2FA = () => {
  return POST(`${ORG_USER_PROFILE}/2fa/disable`);
};

